import {
  AddOutlined,
  AutoGraphOutlined,
  BubbleChart,
  FaceRetouchingNaturalOutlined,
  HelpOutlineOutlined,
  RestoreOutlined,
  SettingsOutlined,
  DonutSmallOutlined,
} from "@mui/icons-material";
import {
  Badge,
  Box,
  Button,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useSnackbar } from "notistack";
import { useLocation } from "react-router-dom";
// import { logoURL } from "../config";
import useChatbot from "../../provider/chatbot_provider";
import logo from "../../assets/images/logo.png";
import askTaraLogo from "../../assets/images/alembic_ask_tara_logo.png";
import useIdleLogout from "../../idleLogout";
import useAuthRedirect from "../../userAutoRedirect";

export default function ChatbotNavbar({ tool }: { tool: string }) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const { chats, selectedChat, newChat, setSelectedChat } = useChatbot();
  const { pathname } = useLocation();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  useIdleLogout();
  const checkSession = () => {
    return !!sessionStorage.getItem("userDetails");
  };
  const sessionExists = checkSession();
  useAuthRedirect(sessionExists);
  if (!sessionExists) {
    return null;
  }

  function comingSoon() {
    enqueueSnackbar("Coming soon.");
  }

  return !isSmallScreen ? (
    <Box
      width={240}
      boxShadow={1}
      bgcolor={"white"}
      display="flex"
      flexDirection="column"
    >
      <Box
        p={3}
        component="div"
        style={{
          textDecoration: "none",
          color: "inherit",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img
          src={logo}
          style={{ height: "100%", width: "67%", objectFit: "fill" }}
        />
      </Box>
      {/* <Box p={4}>
        <a href="/" style={{ textDecoration: "none", color: "inherit", display: "flex", justifyContent: "center", alignItems: "center" }}>
          <img
            src={logo}
            style={{ height: "80%", width: "80%", objectFit: "fill" }}
          />
        </a>
      </Box> */}

      <Box>
      <Box
        component="div"
        style={{
          textDecoration: "none",
          color: "inherit",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img
          src={askTaraLogo}
          style={{ height: "100%", width: "60%", objectFit: "fill" }}
        />
      </Box>
        <Typography align="center" sx={{ fontSize: "15px" }}>
          Alembic AI Assistant
        </Typography>
      </Box>
      <Button
        endIcon={<AddOutlined />}
        variant="contained"
        color="primary"
        sx={{
          p: 0.75,
          m: 1.75,
          borderRadius: 10,
          width: "unset",
          background:
            "linear-gradient(to right, #04A05F 40%, #0D8C8D 60%, #1879BB 100%)",
          color: "white",
          transition: "background 0.3s ease",
          "&:hover": {
            background:
              "linear-gradient(to right, #5EBF94 40%, #5DB7B8 60%, #6EA7D4 100%)",
          },
          fontSize: "15px",
        }}
        onClick={newChat}
      >
        New chat
      </Button>
      <Box
        flex={1}
        overflow={"scroll"}
        sx={{
          "&::-webkit-scrollbar": {
            display: "none",
          },
        }}
      >
        <Typography
          mx={2}
          variant="caption"
          sx={{ fontSize: "16px", fontWeight: "600" }}
        >
          History{" "}
          <span style={{ fontSize: "12px", fontWeight: "500" }}>
            {"(Last 7 Days)"}
          </span>
        </Typography>
        <List>
          {chats
            .map((chat, index) => ({ chat, originalIndex: index }))
            .reverse()
            .map(({ chat, originalIndex }) => (
              <ListItem
                button
                selected={selectedChat === originalIndex}
                key={originalIndex}
                onClick={() => setSelectedChat(originalIndex)}
                sx={{
                  "&:hover": {
                    backgroundColor: "rgba(246,248,246,255)",
                  },
                  "&.Mui-selected": {
                    backgroundColor: "rgba(196,228,255,255)",
                    "&:hover": {
                      backgroundColor: "rgba(246,248,246,255)",
                    },
                  },
                  "&.Mui-focusVisible": {
                    backgroundColor: "rgba(246,248,246,255)",
                  },
                }}
              >
                <ListItemIcon sx={{ fontSize: "15px", minWidth: "25px" }}>
                  <BubbleChart sx={{ fontSize: "15px" }} />
                </ListItemIcon>
                <ListItemText
                  primary={
                    chat.conversations.length > 0
                      ? chat.conversations[0].query
                      : chat.title
                  }
                  primaryTypographyProps={{
                    textOverflow: "ellipsis",
                    noWrap: true,
                    fontSize: "15px",
                  }}
                ></ListItemText>
              </ListItem>
            ))}
        </List>
        <Box m={2}>{/* <Divider /> */}</Box>
      </Box>
      <Divider />
      <Box>
        <Divider />
        <Box
          p={1.7}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
          width={"100%"}
        >
          <Typography sx={{ color: "#9ba1a8", fontSize: "15px" }}>
            Powered By Alembic AI
          </Typography>
        </Box>
      </Box>
    </Box>
  ) : null;
}
